import { Component, OnInit, OnDestroy} from '@angular/core';
import { TaskList, TaskListService } from 'src/app/core/http/taskList/task-list.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit, OnDestroy  {
  course_id: string;
  lesson_id: string;
  theory: string;
  name: string = 'name';
  tasks: TaskList[];
  subsc: Subscription;
  NavEnd: Subscription;

  constructor(private TaskListServices: TaskListService,private route: ActivatedRoute, private router: Router, private titleService: Title) {
    this.NavEnd = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.course_id = this.route.snapshot.paramMap.get("course");
        this.lesson_id = this.route.snapshot.paramMap.get("lesson");
        this.getTasks();
        this.titleService.setTitle(this.name);
        console.log(this.name);
      }
    })
  }

  ngOnInit() {
  }

  getTasks() {
    this.subsc = this.TaskListServices.getAll(this.lesson_id)
    .subscribe(resp => {
      this.tasks = resp;
    });
  }
  ngOnDestroy() {
    this.subsc.unsubscribe();
    this.NavEnd.unsubscribe();
  }

}
